/**
 * Tiny module owning the "sign-out in progress" flag. Extracted from
 * client.ts so sessionExpired.ts can import it without creating a
 * circular dependency between client.ts ↔ sessionExpired.ts.
 *
 * The flag is set by AuthProvider's signOut() before calling the
 * BetterAuth signOut endpoint, and cleared by AuthProvider after the
 * call returns (success or error). While the flag is true, the global
 * 401 interceptor in sessionExpired.ts skips redirecting — the user is
 * intentionally leaving the session.
 */
let _isSigningOut = false;

export function setSigningOut(value: boolean) {
  _isSigningOut = value;
}

export function isSigningOut(): boolean {
  return _isSigningOut;
}
